









































import Vue from "vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"
import { StandardApplicationError } from "~/errorHandlers"
import CorporationMemberInvitationThanksModal from "~/components/custom/profileDetail/local/myPage/CorporationMemberInvitationThanksModal.vue"
import { BackendApi } from "~/backendApis"
import {
  CorporationMemberInvitationView,
  CorporationMemberInvitationListView,
} from "~/backendApis/viewModel"

interface DataType {
  invitation: CorporationMemberInvitationView | null
  inviteeCompanyName: string
  isVisibleThanksModal: boolean
}

export default Vue.extend({
  components: {
    MaterialIcon,
    ConversionButton,
    CorporationMemberInvitationThanksModal,
  },
  data(): DataType {
    return {
      invitation: null,
      inviteeCompanyName: "",
      isVisibleThanksModal: false,
    }
  },
  computed: {
    iconType() {
      return { OUTLINED }
    },
  },
  created() {
    new BackendApi.User.CorporationAccount.GetMyUndecidedInvitationListReadRequest()
      .get()
      .then((invitationList: CorporationMemberInvitationListView) => {
        if (invitationList.list.length > 0) {
          const invitation = invitationList.list[0]
          this.invitation = invitation
          this.inviteeCompanyName = invitation.corporationNameOfInviter
        }
      })
  },
  methods: {
    async approveInvitation() {
      if (!this.invitation) {
        this.throwInvitationStateError()
        return
      }

      await new BackendApi.User.CorporationAccount.ApproveCorporationMemberInvitationWriteRequest(
        {
          invitationId: this.invitation.id,
        }
      ).post()

      this.initInvitation()
      this.openCorporationMemberInvitationThanksModal()

      this.$emit("approved")
    },
    async rejectInvitation() {
      if (!this.invitation) {
        this.throwInvitationStateError()
        return
      }

      await new BackendApi.User.CorporationAccount.RejectCorporationMemberInvitationWriteRequest(
        {
          invitationId: this.invitation.id,
        }
      ).post()

      this.initInvitation()

      this.$clStores.flashMessage.actions.drawFlashSuccess(
        "メンバーの招待を却下しました"
      )
    },
    throwInvitationStateError() {
      throw new StandardApplicationError(
        "招待結果申請時に対象の招待データが設定されていませんでした"
      )
    },
    initInvitation() {
      this.invitation = null
    },
    openCorporationMemberInvitationThanksModal() {
      this.isVisibleThanksModal = true
    },
    closeCorporationMemberInvitationThanksModal() {
      this.isVisibleThanksModal = false
    },
  },
})
